module.exports = __webpack_public_path__ + "static/media/functionalSticker-small.ac5554ed.jpg";